<script>
    import {External, M} from "../external";

    let data = {};

    function showPopup() {
        External.Tools.chooseMultiple({
            title: M.SELECT_MEMBER_GROUPS,
            message: '',
            noItemsMessage: M.NO_MEMBER_GROUPS,
            items: External.Website.memberGroups,
            selectedItems: [],
            isModal: true,
            getItemId: function (group) {
                return group.id;
            },
            getItemText: function (group) {
                return group.name;
            },
            onSelect: function (newGroups) {
                data = Object.assign({}, data, {memberGroups: newGroups.map(g => g.id)});
            }
        });
    }

    export function get() {
        return data;
    }
</script>
<div class="popup-input-wrapper">
    <h5>{M.NAME}</h5>
    <input type="text" name="memberName" placeholder="{M.NAME}" bind:value={data.name}
           class="focus transition-border">
</div>
<div class="popup-input-wrapper">
    <div class="info">
        <h5>{M.EMAIL}</h5>
        <span>{M.USED_TO_LOGIN}</span>
    </div>
    <input type="text" name="memberEmail" placeholder="{M.EMAIL}" bind:value={data.email} class="transition-border">
</div>
<div class="input-wrapper">
    <a class="middle-button gray choose-groups" on:click={showPopup}>{M.CHOOSE_MEMBER_GROUPS}</a>
</div>
